// extracted by mini-css-extract-plugin
module.exports = {"baseTriangle":"styles_baseTriangle__2UpoI","triangleUp":"styles_triangleUp__3TBZG","triangleDown":"styles_triangleDown__3zYj5","activeTriangle":"styles_activeTriangle__3S89l"};